<template>
  <section>
    <HeroSection headName="Cadastro de Usuário" :searchBar="false" :addButton="false">
    </HeroSection>

    <div class="container">

      <form class="form">
        <div class="form__box" v-if="loading">
          <h2 class="form__name">
            <DataLoading rows="1" height="50px" />
          </h2>

          <div class="form__content">
            <DataLoading rows="4" height="80px" />
          </div>
        </div>

        <div class="form__wrap" v-if="!loading">
          <div class="form__box" v-if="isUserAdmin()">
            <h2 class="form__name">
              Dados Gerais
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormInput label="Utilizador" :required="true" v-model:modelValue="model.senderName"/>
              </div>

              <div class="form__row">
                <FormSelect label="Permissão" :required="true" :dataList="userRoles()" v-model:modelValue="model.senderRole" />
              </div>
            </div>
          </div>

          <div class="form__box" v-if="isUserAdmin()">
            <h2 class="form__name">
              Dados de Envio
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormInput label="E-mail de Resposta (ReplyTo)" :required="true" v-model:modelValue="model.senderReplyToEmail"/>
              </div>

              <div class="form__row">
                <FormSelect label="Tipo de Envio" :required="true" :dataList="userTypes()" v-model:modelValue="model.senderAwsConfig" />
              </div>

              <div class="form__row form__row--nowrap">
                <FormCheckbox label="Utilizador Ativo" :required="true" v-model:modelValue="model.senderActive" />
              </div>
            </div>
          </div>

          <div class="form__box">
            <h2 class="form__name">
              Dados de Acesso
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormInput label="Token" :required="false" v-model:modelValue="model.senderAuthToken" :disabled="true"/>

                <FormInput label="Usuário de Acesso" :required="true" v-model:modelValue="model.senderUserAccess"/>

                <FormInput label="Senha" :required="true" v-model:modelValue="model.senderPassword"/>
              </div>
            </div>
          </div>

          <div class="form__box" v-if="isUserAdmin()">
            <h2 class="form__name">
              Imagem Administativa
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormImage label="Logomarca do Usuário" v-model:modelImage="model.senderImage" :imgWidth="200" :imgHeight="200" />
              </div>
            </div>
          </div>

          <div class="form__box">
            <h2 class="form__name">
              Logo no Email
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormImage label="Logomarca do Usuário" v-model:modelImage="model.senderMailLogo" :imgWidth="240" :imgHeight="100" />
              </div>

              <div class="form__row">
                <FormInput label="Cor Primária" :required="true" v-model:modelValue="model.senderMailColor1" width="50%" />

                <FormInput label="Cor Secundária" :required="true" v-model:modelValue="model.senderMailColor2" width="50%"/>
              </div>
            </div>
          </div>

          <FormBottom :data="button" @submit="submit()" />

        </div>
      </form>
    </div>
  </section>
</template>

<script>

import HeroSection from '@components/_partials/HeroSection.vue';
import DataLoading from '@components/_partials/DataLoading.vue';
import FormInput from '@components/_form/FormInput.vue';
import FormSelect from '@components/_form/FormSelect.vue';
import FormCheckbox from '@components/_form/FormCheckbox.vue';
import FormBottom from '@components/_form/FormBottom.vue';
import FormImage from '@components/_form/FormImage.vue';
import { userRoles, userTypes } from '@helpers/constants';
import { baseUrl, padVal, brDate, globalDate, docMask, phoneMask } from '@helpers/functions';
import usuario from '@services/usuario';
import storage from 'storage';

export default {
  components: {
    HeroSection,
    DataLoading,
    FormInput,
    FormSelect,
    FormBottom,
    FormCheckbox,
    FormImage
  },
  data() {
    return {
      loading: false,
      button: { spinner: false, label: 'Salvar Usuário', color: 'primary' },
      model: { },
      dataList: [],
      pagination: {},
      search: ''
    }
  },
  methods: {
    baseUrl,
    brDate,
    padVal,
    docMask,
    phoneMask,
    userTypes,
    userRoles,
    loadForm: function(_id) {
      const _this = this;
      _this.loading = true;

      usuario.show(_id).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.model = res.data;
          _this.loading = false;

          _this.model.senderPassword = '';
          _this.model.created_at = globalDate(_this.model.createdAt);
        }
      });
    },
    submit() {
      const _this = this;
      const _id = _this.hasIdx();
      const button = _this.button;
      let data = _this.model;

      _this.button = {
        spinner: true,
        label: 'Salvando...',
        color: 'warning'
      }
      usuario.save(_id, data).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.button = {
            spinner: false,
            label: 'Salvo com sucesso!',
            color: 'success'
          }

          setTimeout(() => this.$router.push('/usuarios'), 1000);
        }

        if(typeof res === 'undefined' || !res.success) {
          _this.button = {
            spinner: false,
            label: 'Houve um erro ao processar.',
            color: 'danger'
          }

          setTimeout(() => _this.btnLabel = button, 3000);
        }
      })

    },
    hasIdx() {
      const _this = this;
      return _this.$route.params.id ? _this.$route.params.id : null;
    },
    isUserAdmin() {
      const local = 'mail4fly--user';
      const user = storage.get(local);
      console.log('user.role', user.role)
      return user && user.role === 'admin' ? true : false;
    }
  },
  watch: {
    '$route.params.page'(paged) {
     this.initLoad(paged);
    }
  },
  mounted(){
    const _id = this.hasIdx();
    if(_id) this.loadForm(_id);
  }
};

</script>
